import { useState, useEffect, useCallback } from 'react';

const useFetchAllJobs = ({ filters = {}, page = 1, limit = 10, searchTerm, orderBy }) => {
  const [posts, setPosts] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalJobs, setTotalJobs] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchJobs = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const query = new URLSearchParams({
        ...filters,
        q: searchTerm,
        page,
        limit,
        orderBy
      }).toString();

      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/jobs?${query}`);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch jobs: ${response.status} - ${errorText}`);
      }
   
      const data = await response.json();
   
      // Response structure: { success: true, data: [...], totalPages, totalJobs, currentPage }
      setPosts(Array.isArray(data.data) ? data.data : []);
      setTotalPages(data.totalPages || 1);
      setTotalJobs(data.totalJobs || 0);
    } catch (error) {
      setError(error.message);
      console.error('Error fetching jobs:', error);
    } finally {
      setIsLoading(false);
    }
  }, [filters, searchTerm, page, limit, orderBy]);
  
  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  return { posts, totalPages, totalJobs, isLoading, error };
};

export default useFetchAllJobs;

